/******************************************************
*
* Tiny class to wrap axios calls, their only purpose
* is to provide base url and basic http methods
*
* All rights reserved (c) Launchmetrics
******************************************************/

import axios from "axios";

const APIURL = process.env.REACT_APP_API_URL;

export default class K2Api {
	constructor() {
		this._axios = axios.create({
			baseURL: APIURL,
			timeout: 300000,
			withCredentials: true,
		});

		// When content-type text/plain es returned, we set response text as data to avoid json decode issues like BIT-1742
		this._axios.interceptors.response.use(response => {
			return response;
		}, error => {
			const contentType = error.response.headers['content-type'];
			if (contentType.match(/^text\/plain(^|;)/)) {
				error.response.data = error.response.request.responseText;
			}
			if (error.response && error.response.status === 401) {
				const requestUrl = error.config.url;
				if (!requestUrl.startsWith('/session')) {
					const currentUrl = new URL(window.location.href);
					const redirectUrl = `${process.env.REACT_APP_BSSO_URL}/?next=${encodeURIComponent(currentUrl.href)}&connect=${encodeURIComponent(currentUrl.origin + '/bsso/connect')}`;
					localStorage.setItem('redirectUrl', redirectUrl);
					window.location.href = currentUrl.origin + '/error/401';
				}
			}

			return Promise.reject(error);
		});
	}

	get(url, config) {
		return this._axios.get(url, config);
	}

	post(url, data, config) {
		return this._axios.post(url, data, config);
	}

	put(url, data, config) {
		return this._axios.put(url, data, config);
	}

	delete(url, config) {
		return this._axios.delete(url, config);
	}
}
